<script lang="ts">
	import EditDeviceWizard from 'src/components/Devices/DeviceWizard/EditDeviceWizard.svelte';
	import { Button, Text } from '@Shelly/shelly-design-system/index';
	import { devices } from 'src/stores/lists/devices';
	import { format } from 'svelte-i18n';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device;
	export let showModalEdit = false;
	export let showModalEditFromNotification = false;

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: () => (showModalEdit = true),
				loading: false,
				disabled: false,
				label: $format('button_edit_device', { default: 'Edit device' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Text styleType="body-small" class="mb-m">
	{$format('text_edit_device', {
		default: "Edit the device's appearance in the app by changing its room, name and avatar.",
	})}
</Text>

{#if !$showNewLayout}
	<Button size="m" width="full" on:click={() => (showModalEdit = true)}>
		{$format('button_edit_device', { default: 'Edit device' })}
	</Button>
{/if}

{#if showModalEdit || showModalEditFromNotification}
	<EditDeviceWizard
		bind:editDevice={device}
		bind:showModalEdit
		bind:showModalEditFromNotification
		on:finish={() => (device = $devices[device.id])}
	/>
{/if}
